<template lang="html">
 <transition name="move">
  <div class="orders" v-show="showFlag" ref="orders">
    <div class="orders-content">
        <div class="rating-wrapper">
            <ul>
            <li class="rating-item" v-for="item in orders" @click="selectFood(item,$event)">
                <div class="content">
                  <!-- 金额 -->
                <p class="text">{{ $t("total") }}：{{item.Total}} €</p> 
                <div class="star-wrapper">
                    <span class="delivery" >{{item.Status}}</span>
                </div> 
                <div class="star-wrapper">
                    <span class="delivery" >{{item.Sheet}}</span>
                </div> 
                <div class="star-wrapper">
                    <span class="delivery" >{{ $t("address") }}: {{item.Address}}</span>
                </div>
                <div class="time">
                  {{item.OrderDate | changeDate}}
                </div>
                </div>
            </li> 
            </ul>
        </div>      
    </div>
  <orderdetails :orderdetailsobj="orderdetailsobj" ref="orderdetails"></orderdetails>
  </div>
</transition>
</template>

<script>
import BScroll from 'better-scroll'
import orderdetails from 'components/orders/orderdetails.vue'
import {formateDate} from 'common/js/date.js'
import eventbus from '../../common/js/eventbus.js'
export default {
  props: {},
  data() {
    return {
      orders: [],
      orderdetailsobj: [],
      showFlag: false,
      state: this.$store.state
    }
  },
  methods: {
    show(status) {
      // 加入状态过滤,show的时候才刷新数据,如果是created就读取api,那就不是刷新了,而是进入我的信息页面就立刻读取.费流量
      this.showFlag = true
      status = status || ''
      this.$http.get(this.api.getOrderAll + '?openId=' + (this.state.myinfo.openId || '1234') + '&SellerID=' + (this.state.myinfo.SellerID || 1) + '&status=' + status + this.state.ibnumber).then((res) => {
        this.orders = res.data.data.prods
        if (this.$store.state.dev) console.log('刷新单据', res.data.data.prods)
        this.$nextTick(() => {
          this.scroll = new BScroll(this.$refs.orders, {
            click: true
          })
        })
      })
      eventbus.$emit('returnfun', this.hide)
    },
    hide() {
      if (this.$refs.orderdetails.isshow()) {
        this.$refs.orderdetails.hide()
        return
      }
      this.showFlag = false
    },
    isshow() {
      return this.showFlag
    },
    selectFood(data, e) {
      if (!event._constructed) {
        return
      }
      if (this.$store.state.dev) console.log('单据 selectFood - data', data)

      this.orderdetailsobj = data.OrderDetails
      this.$refs.orderdetails.show()
    }
  },
  filters: {
    changeDate(time) {
      let date = new Date(time)
      return formateDate(date, 'dd/MM/yyyy hh:mm:ss')
    }
  },
  created() {
  },
  components: {
    orderdetails
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.orders {
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 45px;
    width: 100%;
    background: #fff;
    overflow: hidden;
    &.move-enter-active,
    &.move-leave-active {
        // 动画过程
        transition: all 0.5s;
        transform: translate3d(0, 0, 0);
    }
    &.move-enter,
    &.move-leave-to {
        // 动画初始态
        transform: translate3d(100%, 0, 0);
    }
    .rating-wrapper {
        padding: 0 18px;
        .rating-item {
            display: flex;
            padding: 18px 0;
            @include border-1px(rgba(7, 17, 27, 0.1));
            .avatar {
                flex: 0 0 28px;
                width: 28px;
                height: 28px;
                margin-right: 12px;
                border-radius: 50%;
                overflow: hidden;
                img {
                    width: 100%;
                }
            }
            .content {
                position: relative;
                flex: 1;
                .name {
                    margin-bottom: 4px;
                    line-height: 14px;
                    font-size: 12px;
                    color: rgb(7, 17, 27);
                }
                .star-wrapper {
                    margin-bottom: 6px;
                    font-size: 0;
                    .star {
                        display: inline-block;
                        vertical-align: top;
                        margin-right: 6px;
                    }
                    .delivery {
                        display: inline-block;
                        vertical-align: top;
                        line-height: 12px;
                        font-size: 11px;
                        color: rgb(147, 153, 159);
                    }
                }
                .text {
                    margin-bottom: 8px;
                    line-height: 18px;
                    font-size: 12px;
                    color: rgb(7, 17, 27);
                }
                .time {
                    position: absolute;
                    top: 0;
                    right: 0;
                    line-height: 12px;
                    font-size: 10px;
                    color: rgb(7, 17, 27);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// orders.vue?02441f78